import { render } from "./UserCart.vue?vue&type=template&id=8f42f18c&scoped=true"
import script from "./UserCart.vue?vue&type=script&lang=js"
export * from "./UserCart.vue?vue&type=script&lang=js"

import "./UserCart.vue?vue&type=style&index=0&id=8f42f18c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f42f18c"]])

export default __exports__